/**
 * Extracts the child key from an event property rule string. The string should contain at most one instance of
 * children[<childKey>].
 *
 * Child keys are item names, which may themselves contain brackets (e.g. `children[Compressor Power [ test ]]`), so
 * the closing bracket is only the one followed by `.` or the end of the accessor. This mirrors the backend parsing in
 * `HierarchyEvent.CHILD_NAME_REGEX`.
 */
export const extractChildKeyFromString = (value: string) => {
  const matches = value.match(/children\[(.+?)](?=\.|$)/);
  return matches?.length === 2 ? matches[1] : undefined;
};
